export const AppPermissions = {
  SELLER_CANCEL_SALES_ORDER: 'update:seller_cancel_sales_order',
  SELLER_APPROVE_SALES_ORDER: 'update:seller_approve_sales_order',
} as const;
